import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { filter } from 'lodash'
import { usePackageImportsSafe } from '../../contexts/PackageImportsContext'

function usePendingChangesPackageImports() {
  const { teamSlug } = useParams()
  const { packageImports, loading, reload } = usePackageImportsSafe()

  const pendingPackageImports = useMemo(
    () => filter(packageImports, { pendingChanges: true }),
    [packageImports]
  )

  return {
    packageImports: pendingPackageImports,
    pendingChangesCount: pendingPackageImports.length,
    loading,
    reload,
    teamSlug,
  }
}

export default usePendingChangesPackageImports
